// Small uppercase label with ▾ prefix and color variants.
// Usage: <Eyebrow color="gold">FEATURED · 2026 PREVIEW</Eyebrow>

export default function Eyebrow({ children, color = 'gold', className = '' }) {
  const colorClass = {
    gold: 'text-accent-gold',
    red: 'text-accent-red',
    muted: 'text-ink-tertiary',
  }[color] || 'text-accent-gold';

  return (
    <div className={`text-eyebrow ${colorClass} ${className}`}>
      ▾ {children}
    </div>
  );
}
